import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../App';
import AppTopHeader from '../components/AppTopHeader';

const BuyQRCodeProcessingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { paymentResponse, orderData } = location.state || {};

  useEffect(() => {
    if (!paymentResponse || !orderData) {
      navigate('/buy-qr', { replace: true });
      return;
    }

    const verifyPayment = async () => {
      try {
        const verifyResponse = await axios.post(`${API}/payment/verify`, {
          razorpay_order_id: paymentResponse.razorpay_order_id,
          razorpay_payment_id: paymentResponse.razorpay_payment_id,
          razorpay_signature: paymentResponse.razorpay_signature,
        });

        toast.success('Order placed successfully!');
        navigate('/buy-qr/success', {
          replace: true,
          state: {
            order: {
              displayOrderId:
                verifyResponse.data.display_order_id ||
                orderData.display_order_id ||
                verifyResponse.data.order_id ||
                paymentResponse.razorpay_order_id,
              quantity: orderData.quantity,
            },
          },
        });
      } catch (error) {
        toast.error('Payment verification failed. Please contact support.');
        navigate('/buy-qr', { replace: true });
      }
    };

    verifyPayment();
  }, [paymentResponse, orderData, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <AppTopHeader backLabel="Back" />
      <div className="max-w-3xl mx-auto px-4 py-8 flex items-center justify-center">
        <div className="bg-white rounded-3xl border border-slate-200 shadow-lg p-10 text-center max-w-md">
          <div className="mb-6 flex justify-center">
            <div className="relative w-16 h-16">
              <div className="absolute inset-0 rounded-full bg-blue-100 flex items-center justify-center">
                <Loader2 className="w-8 h-8 text-blue-800 animate-spin" />
              </div>
            </div>
          </div>

          <h1 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Barlow' }}>
            Processing Your Order
          </h1>
          <p className="text-slate-600 mb-2">
            Your payment has been received successfully.
          </p>
          <p className="text-sm text-slate-500">
            We're processing your order. Please wait while we confirm everything. You'll be redirected shortly.
          </p>

          <div className="mt-8 pt-6 border-t border-slate-200">
            <div className="flex items-center justify-center gap-2 text-sm text-slate-500">
              <CheckCircle2 className="w-4 h-4 text-emerald-600" />
              <span>Payment verified</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyQRCodeProcessingPage;
